import {useStore} from '@/store/root-store';
import {opaqueColor} from '@/utils/colors';
import {faCircleInfo} from '@fortawesome/pro-duotone-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Popover} from 'antd';
import {observer} from 'mobx-react';
import {useEffect, useState} from 'react';
import styled from 'styled-components';

export const MissingPlacementsBanner = observer(() => {
  const [show, setShow] = useState<boolean>(true);
  const [termsWithNoSuggestions, setTermsWithNoSuggestions] = useState<any[]>([]);

  const {
    contentOptimizer: {
      currentPage: {
        termsForInsertion,
        termsAssistantSuggestions,
      },
    }} = useStore('');

  useEffect(() => {
    const prepArr = [];
    for (let i = 0; i < termsForInsertion?.length; i++) {
      if (!termsAssistantSuggestions?.find(item => item.termIncluded?.includes(termsForInsertion[i].name))) {
        prepArr.push(termsForInsertion[i].name);
      }
    }

    setTermsWithNoSuggestions(prepArr);
  }, [...(termsForInsertion ?? []), ...(termsAssistantSuggestions ?? [])]);

  const noPlacementsTermsCount = () => {
    const content = (
      <div style={{fontSize: 12}}>
        {termsWithNoSuggestions?.map((term, idx) => {
          return <div key={idx} style={{cursor: 'default'}}>{`‧ ${term}`}</div>;
        })}
      </div>
    );


    return <Popover trigger={'click'} content={content} placement='bottomLeft' autoAdjustOverflow={true} overlayInnerStyle={{maxHeight: 400, overflowY: 'auto'}}>
      <span style={{textDecoration: 'underline', cursor: 'pointer', marginLeft: 5}}>
        {termsWithNoSuggestions?.length > 1 ? `${termsWithNoSuggestions?.length} terms` : '1 term'}
      </span>
    </Popover>;
  };

  return (show && termsWithNoSuggestions?.length > 1) ?
    <Wrapper>
      <FontAwesomeIcon icon={faCircleInfo} color='#F1AA3E' style={{marginRight: 5}} fontSize={14}/>
      <div>
        We could not find a placement for
        {noPlacementsTermsCount()}
      </div>
      <div style={{color: '#34AEF3', cursor: 'pointer', marginLeft: 'auto', marginRight: 10}} onClick={() => setShow(false)}>Dismiss</div>
    </Wrapper> :
    <></>;
});

const Wrapper = styled.div`
  width: 100%;
  background-color: ${opaqueColor('#F1AA3E', 15)};
  padding: 9px 12px;
  display: flex;
  cursor: default;
  font-size: 12px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
`;
